import { useEffect, useState } from 'react'
import { Input, Select, Form, Space, Button, InputNumber } from 'antd'
import { observer } from 'mobx-react-lite'
import { GLOBAL_CLIENT } from '../../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { showMessageError, showMessageSuccess } from '../../../helpers/functions'

import { useStore } from '../../../hooks'
import { MinMaxConfigDesigner } from 'src/helpers/constants'
const { Option } = Select

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
   }
}

const DesignerConfigManagement = observer((props: any) => {
   const { t } = useTranslation()

   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [isLoading, setIsLoading] = useState(false)
   const CommonConfigStore = useStore('CommonConfigStore')
   const { designerConfigList } = CommonConfigStore
   const [form] = Form.useForm()

   const [fields, setFields] = useState<any>([])
   const [timeJob, settimeJob] = useState('')
   const [amountHold, setamountHold] = useState('')
   const [minWithdraw, setminWithdraw] = useState('')
   const [rangeDate, setrangeDate] = useState('')
   // const [linkSupport, setlinkSupport] = useState('')
   const [maxReceive, setmaxReceive] = useState('')
   const [minRecharge, setMinRecharge] = useState('')
   const [rangeJobFinish, setRangeJobFinish] = useState('')
   const [jobCancelInDay, setJobCancelInDay] = useState('')
   const [jobPriorityInDay, setJobPriorityInDay] = useState('')
   const [jobReviveFree, setJobReviveFree] = useState('')
   const [maxTarget, setMaxTarget] = useState('')
   const [timeDeleteTag, setTimeDeleteTag] = useState('')

   useEffect(() => {
      getConfigDesigner()

      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])
   useEffect(() => {
      setFields([
         { name: 'timeJob', value: designerConfigList?.timeJob },
         { name: 'amountHold', value: designerConfigList?.amountHold },
         { name: 'minWithdraw', value: designerConfigList?.minWithdraw },
         { name: 'rangeDate', value: designerConfigList?.rangeDate },
         { name: 'linkSupport', value: designerConfigList?.linkSupport },
         { name: 'maxReceive', value: designerConfigList?.maxReceive },
         { name: 'rangeJobFinish', value: designerConfigList?.rangeJobFinish },
         { name: 'minRecharge', value: designerConfigList?.minRecharge },
         { name: 'jobCancelInDay', value: designerConfigList?.jobCancelInDay },
         { name: 'jobPriorityInDay', value: designerConfigList?.jobPriorityInDay },
         { name: 'jobReviveFree', value: designerConfigList?.jobReviveFree },
         { name: 'maxTarget', value: designerConfigList?.maxTarget },
         { name: 'timeDeleteTag', value: designerConfigList?.timeDeleteTag },
         { name: 'jobCallbackUrl', value: designerConfigList?.jobCallbackUrl }
      ])
      settimeJob(designerConfigList?.timeJob)
      setamountHold(designerConfigList?.amountHold)
      setminWithdraw(designerConfigList?.minWithdraw)
      setrangeDate(designerConfigList?.rangeDate)
      setmaxReceive(designerConfigList?.maxReceive)
      setMinRecharge(designerConfigList?.minRecharge)
      setRangeJobFinish(designerConfigList?.rangeJobFinish)
      setJobCancelInDay(designerConfigList?.jobCancelInDay)
      setJobPriorityInDay(designerConfigList?.jobPriorityInDay)
      setJobReviveFree(designerConfigList?.jobReviveFree)
      setMaxTarget(designerConfigList?.maxTarget)
      setTimeDeleteTag(designerConfigList?.timeDeleteTag)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [designerConfigList])

   const getConfigDesigner = async () => {
      await CommonConfigStore.getConfigDesigner()
   }

   const handleApply = async (values: any) => {
      //  console.log('Received values of form: ', values)
      // Nut Ap dung goi thang handleApply chu khong qua onFinish nen `rules` cua
      // Form khong chan duoc submit. Server tu choi URL sai dinh dang (Joi .uri)
      // va loi tra ve kho doc, nen chan ngay tai day cho ro rang.
      const jobCallbackUrl = (form.getFieldValue('jobCallbackUrl') || '').trim()
      if (jobCallbackUrl && !/^https?:\/\//i.test(jobCallbackUrl)) {
         showMessageError('URL nhận webhook phải bắt đầu bằng http:// hoặc https://')
         return
      }
      const result = await CommonConfigStore.updateConfigDesigner({
         timeJob: timeJob + '' || MinMaxConfigDesigner.timeJob.min + '',
         amountHold: amountHold + '' || MinMaxConfigDesigner.amountHold.min + '',
         minWithdraw: minWithdraw + '' || MinMaxConfigDesigner.minWithdraw.min + '',
         rangeDate: rangeDate + '' || MinMaxConfigDesigner.rangeDate.min + '',
         linkSupport: form.getFieldValue('linkSupport') + '' || '',
         maxReceive: maxReceive + '' || MinMaxConfigDesigner.maxReceive.min + '',
         rangeJobFinish: rangeJobFinish + '',
         minRecharge: minRecharge + '',
         jobCancelInDay: jobCancelInDay + '',
         jobPriorityInDay: jobPriorityInDay + '',
         jobReviveFree: jobReviveFree + '',
         maxTarget: maxTarget + '',
         timeDeleteTag: timeDeleteTag + '',
         // De trong = tat webhook, nen gui chuoi rong chu khong bo field di
         jobCallbackUrl
      })
      if (result) {
         showMessageSuccess('Cập nhật thành công')
      }
   }

   const onChangeValue = (type: string, value: number | string | undefined | null) => {
      // setPrice(value)
      switch (type) {
         case 'timeJob':
            settimeJob(value + '')
            break
         case 'minWithdraw':
            setminWithdraw(value + '')
            break
         case 'amountHold':
            setamountHold(value + '')
            break
         case 'rangeDate':
            setrangeDate(value + '')
            break
         case 'maxReceive':
            setmaxReceive(value + '')
            break
         case 'rangeJobFinish':
            setRangeJobFinish(value + '')
            break
         case 'minRecharge':
            setMinRecharge(value + '')
            break
         case 'jobPriorityInDay':
            setJobPriorityInDay(value + '')
            break
         case 'jobReviveFree':
            setJobReviveFree(value + '')
            break
         case 'maxTarget':
            setMaxTarget(value + '')
            break
         case 'timeDeleteTag':
            setTimeDeleteTag(value + '')
            break
         default:
            setJobCancelInDay(value + '')
            //maxReceive

            break
      }
   }
   // console.log('data?.timeJob', data?.timeJob, parseInt(data?.timeJob))

   return (
      <div>
         <Form
            {...formItemLayout}
            form={form}
            fields={fields}
            name="DesignerConfig"
            // onFinish={debounce(onFinish, 400)}
            scrollToFirstError
         >
            <Form.Item
               name="timeJob"
               label={t(GLOBAL_CLIENT.thoigianlam1mau) + '(phút)'}
               initialValue={designerConfigList?.timeJob}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                  min={MinMaxConfigDesigner.timeJob.min}
                  max={MinMaxConfigDesigner.timeJob.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('timeJob', value)}
               />
            </Form.Item>

            <Form.Item
               name="amountHold"
               label={t(GLOBAL_CLIENT.sotiengiulaitoithieu) + '(VNĐ)'}
               initialValue={designerConfigList?.amountHold}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  min={MinMaxConfigDesigner.amountHold.min}
                  max={MinMaxConfigDesigner.amountHold.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('amountHold', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                  step={1000}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="minWithdraw"
               label={t(GLOBAL_CLIENT.sotientoithieuduocrut) + '(VNĐ)'}
               initialValue={designerConfigList?.minWithdraw}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  min={MinMaxConfigDesigner.minWithdraw.min}
                  max={MinMaxConfigDesigner.minWithdraw.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('minWithdraw', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                  step={1000}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="minRecharge"
               label={t(GLOBAL_CLIENT.sotientoithieuduocnap) + '(VNĐ)'}
               initialValue={designerConfigList?.minRecharge}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  onChange={(value: number | string | undefined | null) => onChangeValue('minRecharge', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                  step={1000}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="rangeDate"
               label={t(GLOBAL_CLIENT.songaygiua2lanrut)}
               initialValue={designerConfigList?.rangeDate}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  min={MinMaxConfigDesigner.rangeDate0.min}
                  max={MinMaxConfigDesigner.rangeDate0.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('rangeDate', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="rangeJobFinish"
               label={'Ngày tự động chuyển trạng thái'}
               initialValue={designerConfigList?.rangeJobFinish}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  min={0}
                  max={MinMaxConfigDesigner.rangeDate0.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('rangeJobFinish', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="linkSupport"
               initialValue={designerConfigList?.linkSupport}
               label={t(GLOBAL_CLIENT.linkSupporter)}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <Input style={{ backgroundColor: '#fff' }} maxLength={100} />
            </Form.Item>
            <Form.Item
               name="maxReceive"
               label={t(GLOBAL_CLIENT.somautoidaduocnhan)}
               initialValue={designerConfigList?.maxReceive}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  min={MinMaxConfigDesigner.maxReceive.min}
                  max={MinMaxConfigDesigner.maxReceive.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('maxReceive', value)}
               // formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
               // parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="jobCancelInDay"
               label={t(GLOBAL_CLIENT.soluongmauhuytrenngay)}
               initialValue={designerConfigList?.jobCancelInDay}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  // min={MinMaxConfigDesigner.rangeDate0.min}
                  // max={MinMaxConfigDesigner.rangeDate0.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('jobCancelInDay', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="jobPriorityInDay"
               label={t(GLOBAL_CLIENT.soluongmauuutiennhantrenngay)}
               initialValue={designerConfigList?.jobCancelInDay}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  // min={MinMaxConfigDesigner.rangeDate0.min}
                  // max={MinMaxConfigDesigner.rangeDate0.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('jobPriorityInDay', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="jobReviveFree"
               label={t(GLOBAL_CLIENT.soluongjobcothenhantruockhinhanjobuutien)}
               initialValue={designerConfigList?.jobReviveFree}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  // min={MinMaxConfigDesigner.rangeDate0.min}
                  // max={MinMaxConfigDesigner.rangeDate0.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('jobReviveFree', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="maxTarget"
               label={'Số designer gán tối đa'}
               initialValue={designerConfigList?.maxTarget}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  // min={MinMaxConfigDesigner.rangeDate0.min}
                  // max={MinMaxConfigDesigner.rangeDate0.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('maxTarget', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
            <Form.Item
               name="jobCallbackUrl"
               initialValue={designerConfigList?.jobCallbackUrl}
               label={'URL nhận webhook job'}
               extra={'Mỗi lần job đổi trạng thái sẽ POST sang URL này. Để trống = tắt webhook.'}
               rules={[
                  {
                     type: 'url',
                     message: 'URL phải bắt đầu bằng http:// hoặc https://'
                  }
               ]}
            >
               <Input style={{ backgroundColor: '#fff' }} maxLength={255} allowClear placeholder="https://..." />
            </Form.Item>
            <Form.Item
               name="timeDeleteTag"
               label={'Thời gian tự động xoá tag(Phút)'}
               initialValue={designerConfigList?.timeDeleteTag}
               rules={[
                  {
                     required: true,
                     message: t(GLOBAL_CLIENT.vuilongnhapdungdinhdang)
                  }
               ]}
            >
               <InputNumber
                  // min={MinMaxConfigDesigner.rangeDate0.min}
                  // max={MinMaxConfigDesigner.rangeDate0.max}
                  onChange={(value: number | string | undefined | null) => onChangeValue('timeDeleteTag', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               // onChange={() => onChangePrice}
               />
            </Form.Item>
         </Form>
         <div className="text-right">
            <Space>
               <Button onClick={handleApply} type="primary" className="btn-add">
                  {/* <i className="icon icon-add icon-in-button" /> */}

                  {t(GLOBAL_CLIENT.apply)}
               </Button>
            </Space>
         </div>
      </div>
   )
})

export default DesignerConfigManagement
